import React from "react";
import Dashboard from "../../layout/Dashboard/Index";

const Index = () => {
  return <Dashboard />;
};

export default Index;
